import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchGetTodosStatus } from 'store/fetchActions/fetchInputForm';
import ButtonComponent from 'components/Button';
import TooltipHelp from 'components/Tooltip/tooltipHelp';
import { fetchEncaminharRequerimento } from 'store/fetchActions/fetchFormulario';
import { ENUM_MODAL, MSG_CAMPO_OBRIGATORIO, STATUS_REQUERIMENTO } from 'utils/consts';
import { formatterJustificativaEncaminhar } from 'utils/formatter/justificativa';

export const ButtonModalEncaminhar = ({
  getValues,
  setExibirLoading,
  sucessoFinalizar,
  setError,
  isEncaminharSetor,
}) => {
  const dispatch = useDispatch();

  const dadosDetalhar = useSelector(state => state.formulario.dadosExibirDetalhar);
  const listaStatus = useSelector(state => state.status.todosStatus);
  const thisModalState = useSelector(state => state.app.modalEncaminhar);

  const validarCampoAtendente = (setorEncaminharId, justificativa) => {
    if (!setorEncaminharId) {
      setError('setorEncaminharId', { type: 'Custom', message: MSG_CAMPO_OBRIGATORIO });
      return false;
    }
    if (!justificativa) {
      setError('justificativa', { type: 'Custom', message: MSG_CAMPO_OBRIGATORIO });
      return false;
    }
    return true;
  };

  const validarCampoSupervisores = (setorEncaminharId, atendenteEncaminharId, justificativa) => {
    if (!isEncaminharSetor && !atendenteEncaminharId) {
      setError('atendenteEncaminharId', { type: 'Custom', message: MSG_CAMPO_OBRIGATORIO });
      return false;
    }
    if (isEncaminharSetor && !setorEncaminharId) {
      setError('setorEncaminharId', { type: 'Custom', message: MSG_CAMPO_OBRIGATORIO });
      return false;
    }
    if (!justificativa) {
      setError('justificativa', { type: 'Custom', message: MSG_CAMPO_OBRIGATORIO });
      return false;
    }
    return true;
  };

  const getNovoStatus = todosStatus => {
    if (thisModalState?.title === ENUM_MODAL.ENCAMINHAR.SUPERVISOR_SETORIAL) {
      const statusIdentificador = isEncaminharSetor
        ? STATUS_REQUERIMENTO.ENCAMINHADO_ATENDENTE.identificador
        : STATUS_REQUERIMENTO.DIRECIONADO_OUTRO_ATENDENTE.identificador;
      return todosStatus.find(x => x.identificador === statusIdentificador);
    }
    return todosStatus.find(x => x.identificador === STATUS_REQUERIMENTO.ENCAMINHADO_ATENDENTE.identificador);
  };

  const getJustificativaEncaminhar = novoStatus => {
    const id = dadosDetalhar?.id;
    const setorEncaminharId = getValues()?.setorEncaminharId;
    const atendenteEncaminharId = getValues()?.atendenteEncaminharId;
    const justificativa = getValues()?.justificativa;

    if (thisModalState?.title === ENUM_MODAL.ENCAMINHAR.ATENDENTE) {
      return formatterJustificativaEncaminhar(setorEncaminharId, null, id, novoStatus?.id, justificativa);
    }
    if (thisModalState?.title === ENUM_MODAL.ENCAMINHAR.SUPERVISOR) {
      return formatterJustificativaEncaminhar(
        setorEncaminharId,
        atendenteEncaminharId,
        id,
        novoStatus?.id,
        justificativa
      );
    }
    if (thisModalState?.title === ENUM_MODAL.ENCAMINHAR.SUPERVISOR_SETORIAL) {
      return formatterJustificativaEncaminhar(
        setorEncaminharId || dadosDetalhar?.setorId,
        atendenteEncaminharId,
        id,
        novoStatus?.id,
        justificativa
      );
    }
    return null;
  };

  const encaminharRequerimento = () => {
    const setorEncaminharId = getValues()?.setorEncaminharId;
    const atendenteEncaminharId = getValues()?.atendenteEncaminharId;
    const justificativa = getValues()?.justificativa;

    const isValid =
      thisModalState?.title === ENUM_MODAL.ENCAMINHAR.ATENDENTE
        ? validarCampoAtendente(setorEncaminharId, justificativa)
        : validarCampoSupervisores(setorEncaminharId, atendenteEncaminharId, justificativa);

    if (!isValid) return;
    setExibirLoading(true);

    dispatch(fetchGetTodosStatus(listaStatus))
      .then(todosStatus => {
        const novoStatus = getNovoStatus(todosStatus);
        const objetoEncaminhar = getJustificativaEncaminhar(novoStatus);

        dispatch(fetchEncaminharRequerimento(objetoEncaminhar))
          .then(() => sucessoFinalizar())
          .catch(() => setExibirLoading(false));
      })
      .catch(() => setExibirLoading(false));
  };

  const obterDescricao = () => {
    if (!isEncaminharSetor && thisModalState?.title === ENUM_MODAL.ENCAMINHAR.SUPERVISOR_SETORIAL) return 'Direcionar';
    else return 'Encaminhar';
  };

  return (
    <>
      <ButtonComponent text={obterDescricao()} clickAction={() => encaminharRequerimento()} css={{ margin: '5px' }} />
      <TooltipHelp
        text={'Ao encaminhar um requerimento, a Justificativa não é pública, ou seja, o Contribuinte não tem acesso.'}
        style={{ marginTop: '12px' }}
      />
    </>
  );
};

export default ButtonModalEncaminhar;
